// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ShoppingCartFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M8.132 21c-.408 0-.751-.14-1.031-.42-.28-.279-.42-.623-.42-1.03 0-.408.14-.752.42-1.032.28-.28.623-.419 1.031-.419.408 0 .752.14 1.031.42.28.279.42.623.42 1.03 0 .408-.14.752-.42 1.032a1.4 1.4 0 0 1-1.03.419Zm9.074 0a1.4 1.4 0 0 1-1.03-.42c-.28-.279-.42-.623-.42-1.03 0-.408.14-.752.42-1.032.279-.28.623-.419 1.03-.419.408 0 .752.14 1.032.42.28.279.419.623.419 1.03 0 .408-.14.752-.42 1.032-.279.28-.623.419-1.03.419ZM6.752 5.9l2.581 5.43h6.769l2.975-5.43H6.752Zm-.472-.966h14.43l-4.03 7.364H8.898l-1.584 2.9h11.343v.967H5.65l2.653-4.738-3.555-7.46H3V3h2.362l.918 1.934Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ShoppingCartFillOffset: IconOffset = {
    vertical: 11, // Store Custom Code
    horizontal: 12, // Store Custom Code
};

export default React.memo(ShoppingCartFill);
